module.exports = __webpack_public_path__ + "img/heart5.de498403.png";